<template>
    <div class="panel">
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="100"
                    prop="typeName"
                    label="名称" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="remark"
                    label="积分说明" >
                </el-table-column>
                <el-table-column
                    min-width="50"
                    label="分值" >
                    <template slot-scope="scope">
                            <el-input type="age" v-model.number="scope.row.rewardScore" autocomplete="off"></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <span class="fx fx-center" >
                <el-button type="primary" @click="sub()" style="margin-top:10px;width: 13%;">保 存</el-button>
            </span>
        </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        props: [
        ],
        data() {
            return {
                tableData: [
                    {
                        type: 1,
                        typeName: '发作品',
                        remark: '每发送作品获得的分值',
                        rewardScore: 0.0,
                    }, 
                    {
                        type: 2,
                        typeName: '发评论',
                        remark: '每发送一次评论获得的分值',
                        rewardScore: 0.0,
                    }, 
                    {
                        type: 3,
                        typeName: '作品点赞',
                        remark: '作品每点赞一次获得的分值',
                        rewardScore: 0.0,
                    }, 
                    {
                        type: 4,
                        typeName: '备课点赞',
                        remark: '员工备课每点赞一次获得的分值',
                        rewardScore: 0.0,
                    }, 
                    {
                        type: 5,
                        typeName: '代码库点赞',
                        remark: '员工代码库每点赞一次获得的分值',
                        rewardScore: 0.0,
                    }, 
                    {
                        type: 6,
                        typeName: '被点赞',
                        remark: '每被点赞一次获得的分值',
                        rewardScore: 0.0,
                    }, 
                    {
                        type: 7,
                        typeName: '备课分享',
                        remark: '员工备课每分享一次获得的分值',
                        rewardScore: 0.0,
                    }, 
                    {
                        type: 8,
                        typeName: '代码库分享',
                        remark: '员工代码库每分享一次获得的分值',
                        rewardScore: 0.0,
                    }, 
                    {
                        type: 9,
                        typeName: '分享的备课被使用',
                        remark: '员工分享的备课每被使用一次获得的分值',
                        rewardScore: 0.0,
                    }, 
                    {
                        type: 10,
                        typeName: '分享的代码库被使用',
                        remark: '员工分享的代码库每被使用一次获得的分值',
                        rewardScore: 0.0,
                    }, 
                    
                ],
            }
        },
        watch: {
           
        },
        methods: {
            loadData() {//如果有数据就替换 没有就用上面定义的
                this.$ajaxGet("/systemScoreRule/list", (data) => {
                    if(data.result.length > 0){
                        this.tableData = data.result;
                    }
                })
            },
            sub() {
                let data = this.tableData;
                this.$ajaxPost("/systemScoreRule/save", {
                    list: data
                }, (data) => {
                    this.$showSuccess("保存成功");
                    this.loadData();
                })
                return false;
            },
        },
        created() {
            this.loadData();
        }

    }
</script>
